import { render, staticRenderFns } from "./cardRequests.vue?vue&type=template&id=393577a4&scoped=true&"
import script from "./cardRequests.vue?vue&type=script&lang=js&"
export * from "./cardRequests.vue?vue&type=script&lang=js&"
import style1 from "./cardRequests.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393577a4",
  null
  
)

export default component.exports